import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, fleetPath } from '@/lib/api-client';
import type { GeoResolution } from '@/types/provision';

/**
 * GET /geo?ip= — resolve a location from an IP. Enabled only once `ip` looks
 * complete; the wizard's Location step prefills its fields from the result.
 */
export function useResolveGeo(ip: string): UseQueryResult<GeoResolution, Error> {
  return useQuery({
    queryKey: ['fleet', 'geo', ip],
    enabled: /^\d{1,3}(\.\d{1,3}){3}$/.test(ip.trim()),
    staleTime: 5 * 60_000,
    retry: false,
    queryFn: ({ signal }) =>
      apiClient.get<GeoResolution>(fleetPath(`/geo?ip=${encodeURIComponent(ip)}`), signal),
  });
}
